<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <page-tile-title />
      <!-- end page-tile-title -->

      <first-row />
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->
</template>

<script>
import PageTileTitle from '@/components/Utilities/PageTileTitle'
import FirstRow from './containers/FirstRow'
export default {
  components: {
    PageTileTitle,
    FirstRow
  }
}
</script>
